const Datepicker = require('./datepicker.js');

module.exports = {
  install (Vue) {
    Vue.component(Datepicker.componentName, Datepicker);
  }
};
